import React from 'react';
import { VerificationForm } from '@sheerid/jslib';
import '@sheerid/jslib/sheerid.css';
import './App.css';

import { programId } from './programOptions';

// tslint:disable-next-line: function-name
function App() {
    return (
        <div className="sid-body">
            <div className="sid-headband">
                <div className="sid-logo">
                    <img src="https://assets-resources.sheerid.com/sonic/img/sonic_logo.png" alt="Sonic"/>
                </div>
            </div>
            <div className="sid-verification-form">
            <div className="sid-fade-bar">
                    <img src="https://assets-resources.sheerid.com/sonic/img/fade_bar.png" alt="bar"/>
                </div>
                <VerificationForm programId={programId} />
            </div>
         </div>
    );
}

export default App;
